import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "30",
  viewBox: "0 0 28 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.9651 0.103388C12.4298 0.211334 11.9088 0.403568 11.4193 0.67935L2.8083 5.5303C1.07637 6.50625 0 8.38053 0 10.4182V19.5811C0 21.6188 1.07637 23.4938 2.8083 24.469L11.4193 29.3207C13.0281 30.2264 14.9719 30.2264 16.5779 29.3207L25.1917 24.469C25.9761 24.0269 26.6259 23.4007 27.1011 22.6583C27.6765 21.7615 28 20.6953 28 19.5811V10.4182C28 8.38053 26.9236 6.50625 25.1917 5.5303L16.5779 0.67935C15.4614 0.0494143 14.1818 -0.14208 12.9651 0.103388Z",
  fill: "var(--components-main100)",
  "fill-opacity": "0.1"
}, null, -1)
const _hoisted_3 = {
  x: "50%",
  y: "50%",
  "dominant-baseline": "middle",
  "text-anchor": "middle",
  fill: "var(--components-main100)",
  "font-size": "12",
  "font-weight": "bold"
}

import { withDefaults } from 'vue';
  
  interface IProps {
    color?: string;
    number: number;
  }
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'MedalNumber',
  props: {
    color: {},
    number: { default: 0 }
  },
  setup(__props: any) {

  const props = __props;
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("text", _hoisted_3, _toDisplayString(props.number), 1)
  ]))
}
}

})